import { PayloadAction } from "@reduxjs/toolkit";
import { call, put, StrictEffect, takeLatest } from "redux-saga/effects";

import { Paginated } from "@/jenesys-types/data/common";
import { ListQuerySchema } from "@/jenesys-types/data/communication";
import { DataType } from "@/jenesys-types/data/enums";
import { extractError } from "@/jenesys-types/errors";

import { performDataAction } from "@/services/api";

import {
  searchDocumentsFailure,
  SearchDocumentsPayload,
  searchDocumentsSuccess
} from "./documentSearch";

function* searchDocumentsSaga(
  action: PayloadAction<SearchDocumentsPayload>
): Generator<StrictEffect, void, any> {
  const { companyId, query, limit = 10, offset = 0 } = action.payload;

  try {
    const response: Paginated<ListQuerySchema> = yield call(
      performDataAction,
      DataType.CommunicationsQuery,
      "list",
      { companyId },
      {
        search: query,
        limit,
        offset
      }
    );

    yield put(searchDocumentsSuccess(response));
  } catch (error) {
    yield put(searchDocumentsFailure(extractError(error)));
  }
}

export default function* documentSearchSaga() {
  yield takeLatest("documentSearch/searchDocuments", searchDocumentsSaga);
}
